export default {
  zh: {
    domTitle: '数据中心',
    timeText: '时间',
    dataDetails: '数据细节',
    totallivetime: '总开播时长',
    bigTwoTime: '>=2小时',
    receivGiftstreams: 'Receive‘s Gift Streams',
    hostdetails: '主播细节',
    agencysalary: '公会薪资',
    presidentsalary: '公会长薪资',
    otherhostsalary: '其他主播薪资',
    Presidentcommission: '公会长提成',
    Goldsalary: '金币薪资',
    Diamondsalary: '钻石薪资',
    Receivedgold: '收到的金币数',
    diamondsalarylevel: '钻石薪资等级',
    Cleardiamondcount: '清空钻石数',
    Livetime: '开播时长',
    Durationonmic: '在麦时长',
    TotalSalary: '总薪资',
    Receivedcoins: '收到的金币数',
    Coinssalarylevel: '金币薪资等级',
    cancel: '关闭',
    confirm: '确定',
    days: '天',
    notice: '距离结算还有{{n}}天，请尽快使用钱包内的钻石',
    notice2: '距离结算不足1天，请尽快使用钱包内的钻石',
    notice3: '结算薪资后，钻石余额自动清零，如若需要，请提前兑换钻石',
    withdrawnSalary: '已提现薪资'
  },
  tr: {
    domTitle: 'Veri Merkezi',
    timeText: 'Süre',
    dataDetails: 'Veri Detayları',
    totallivetime: 'Toplam Aktif Süre',
    bigTwoTime: '>=2 Saat',
    receivGiftstreams: 'ALTIN HEDEFİ',
    hostdetails: 'Yayıncı Detayları',
    agencysalary: 'TOPLAM AJANS GELİRİ',
    presidentsalary: 'TOPLAM AJANS SAHİBİ GELİRİ',
    otherhostsalary: 'TOPLAM YAYINCI MAAŞI',
    Presidentcommission: 'BAŞKANS KOMİSYONU',
    Goldsalary: 'ALTIN MAAŞI',
    Diamondsalary: 'ELMAS MAAŞI',
    Receivedgold: 'ALINAN ALTIN MİKTARI',
    diamondsalarylevel: 'Elmas Maaş Seviyesi',
    Cleardiamondcount: 'Elmas Sayısını Sıfırla',
    Livetime: 'Aktif Süre',
    Durationonmic: 'Mikrofondaki Süre',
    TotalSalary: 'YAYINCI GELİRİ',
    Receivedcoins: 'ALTIN HEDEFİ',
    Coinssalarylevel: 'Coins maaş seviyesi',
    cancel: 'Lütfen',
    confirm: 'Onayla',
    days: 'Gün',
    notice: 'Henüz {{n}} gün kaldı, lütfen mümkün olan en kısa sürede portföyündeki gemileri kullanın',
    notice2: 'Henüz 1 gün kaldı, lütfen mümkün olan en kısa sürede portföyündeki gemileri kullanın',
    notice3: 'Anlaşmadan sonra, elmas dengesi otomatik olarak temizlenecektir. Lütfen elmasları önceden değiştirin.',
    withdrawnSalary: 'Çekilen Maaş'
  },
  ar: {
    domTitle: 'مركز البيانات',
    timeText: 'وقت',
    dataDetails: 'تفاصيل البيانات',
    totallivetime: 'إجمالي الوقت المباشر',
    bigTwoTime: 'ساعة2',
    receivGiftstreams: 'العملات الذهبيه المحصله',
    hostdetails: 'تفاصيل المضيف',
    agencysalary: 'راتب الوكالة',
    presidentsalary: 'راتب الوكيل',
    otherhostsalary: 'راتب المضيف',
    Presidentcommission: 'نسبة  الوكيل',
    Goldsalary: 'راتب  الكونزات',
    Diamondsalary: 'راتب الماس',
    Receivedgold: 'العملات الذهبيه المحصله',
    diamondsalarylevel: 'مستوى راتب الماسي',
    Cleardiamondcount: 'مسح عدد الماسات',
    Livetime: 'وقت البث',
    Durationonmic: 'وقت تشغيل المايك',
    TotalSalary: 'الرواتب  الاجمالية',
    Receivedcoins: 'العملات الذهبيه المحصله',
    Coinssalarylevel: 'مستوى راتب  الكونزات',
    cancel: 'يلغي',
    confirm: 'نعم',
    days: 'أيام',
    notice: 'الوقت المتبقي للسداد هناك {{n}} يوم، يرجى استخدام الأصل في المحفظة في أقرب وقت ممكن',
    notice2: 'السداد قبلا يوم واحد، يرجى استخدام الأصل في المحفظة في أقرب وقت ممكن',
    notice3: 'بعد السداد، سيتم إزالة رصيد الأصل الخاص بك من قبل، إذا كان هناك حاجة إلى إعادة الصلاحية، يرجى إعادة الصلاحية قبل السداد',
    withdrawnSalary: 'الراتب المسحوب'
  },
  en: {
    domTitle: 'Data center',
    timeText: 'Time',
    dataDetails: 'Data details',
    totallivetime: 'Total live time',
    bigTwoTime: '>=2 hours',
    receivGiftstreams: 'Received coins',
    hostdetails: 'Host details',
    agencysalary: 'Agency salary',
    presidentsalary: 'President salary',
    otherhostsalary: 'Other host salary',
    Presidentcommission: 'President commission',
    Goldsalary: 'Gold Salary',
    Diamondsalary: 'Diamond salary',
    Receivedgold: 'Received gold',
    diamondsalarylevel: 'Diamond Salary Level',
    Cleardiamondcount: 'Clear diamond count',
    Livetime: 'Live time',
    Durationonmic: 'Duration on mic',
    TotalSalary: 'Total Salary',
    Receivedcoins: 'Received Coins',
    Coinssalarylevel: 'Coins salary level',
    cancel: 'Cancel',
    confirm: 'Confirm',
    days: 'day',
    notice: 'There are still {{n}} days until the settlement, please use the diamond in your wallet as soon as possible',
    notice2: 'The settlement is less than 1 day, please use the diamond in your wallet as soon as possible',
    notice3: 'After settlement, the diamond balance will be automatically cleared, if necessary, please exchange the diamond beforehand',
    withdrawnSalary: 'Withdrawn Salary'
  },
  pt: {
    domTitle: 'Centro de dados',
    timeText: 'Tempo',
    dataDetails: 'Detalhes dos dados',
    totallivetime: 'Tempo total ao vivo',
    bigTwoTime: '>=2 horas',
    receivGiftstreams: 'Moedas recebidas',
    hostdetails: 'Detalhes do anfitrião',
    agencysalary: 'Salário da agência',
    presidentsalary: 'Salário do presidente',
    otherhostsalary: 'Salário de outros anfitriões',
    Presidentcommission: 'Comissão do presidente',
    Goldsalary: 'Salário de ouro',
    Diamondsalary: 'Salário de diamante',
    Receivedgold: 'Ouro recebido',
    diamondsalarylevel: 'Nível de salário de diamante',
    Cleardiamondcount: 'Contagem de diamantes limpos',
    Livetime: 'Tempo ao vivo',
    Durationonmic: 'Duração no microfone',
    TotalSalary: 'Salário total',
    Receivedcoins: 'Moedas recebidas',
    Coinssalarylevel: 'Nível de salário de moedas',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    days: 'dia',
    notice: 'Ainda há {{n}} dias até o pagamento, por favor utilize o diamond na sua carteira o mais breve possível',
    notice2: 'O pagamento é menor que 1 dia, por favor utilize o diamond na sua carteira o mais breve possível',
    notice3: 'Após o pagamento, o saldo do diamond será automaticamente zerado, se necessário, por favor troque o diamond antes',
    withdrawnSalary: 'Salário Retirado'
  },
  id: {
    domTitle: 'Pusat Data',
    timeText: 'Waktu',
    dataDetails: 'Rincian Data',
    totallivetime: 'Total waktu siaran',
    bigTwoTime: '>=2 jam',
    receivGiftstreams: 'Koin yang diterima',
    hostdetails: 'Rincian Pembawa Acara',
    agencysalary: 'Gaji Agen',
    presidentsalary: 'Gaji Presiden',
    otherhostsalary: 'Gaji Pembawa Acara Lain',
    Presidentcommission: 'Komisi Presiden',
    Goldsalary: 'Gaji Emas',
    Diamondsalary: 'Gaji Berlian',
    Receivedgold: 'Emas yang diterima',
    diamondsalarylevel: 'Tingkat Gaji Berlian',
    Cleardiamondcount: 'Jumlah Berlian yang Dibersihkan',
    Livetime: 'Waktu Siaran',
    Durationonmic: 'Durasi di Mikrofon',
    TotalSalary: 'Total Gaji',
    Receivedcoins: 'Koin yang diterima',
    Coinssalarylevel: 'Tingkat Gaji Koin',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    days: 'hari',
    notice: 'Belum {{n}} hari setor, silakan gunakan emas yang ada di portofolio segera mungkin',
    notice2: 'Setor kurang dari 1 hari, silakan gunakan emas yang ada di portofolio segera mungkin',
    notice3: 'Setelah setor, saldo emas akan otomatis dikosongkan, jika perlu, silakan bertukar emas sebelum setor',
    withdrawnSalary: 'Gaji yang Ditarik'
  },
  uz: {
    domTitle: "Ma'lumotlar markazi",
    timeText: 'Vaqt',
    dataDetails: "Ma'lumotlar tafsilotlari",
    totallivetime: 'Jami jonli vaqt',
    bigTwoTime: '>=2 soat',
    receivGiftstreams: 'Olingan tanga',
    hostdetails: 'Mehmon tafsilotlari',
    agencysalary: 'Agentlik maoshi',
    presidentsalary: 'Prezident maoshi',
    otherhostsalary: 'Boshqa mehmon maoshi',
    Presidentcommission: 'Prezident komissiyasi',
    Goldsalary: 'Oltin maoshi',
    Diamondsalary: 'Marvarid maoshi',
    Receivedgold: 'Olingan oltin',
    diamondsalarylevel: 'Marvarid maosh darajasi',
    Cleardiamondcount: 'Tozalangan marvaridlar soni',
    Livetime: 'Jonli vaqt',
    Durationonmic: 'Mikrofon davomiyligi',
    TotalSalary: 'Jami maosh',
    Receivedcoins: 'Olingan tangalar',
    Coinssalarylevel: 'Tangalar maosh darajasi',
    cancel: 'Bekor qilish',
    confirm: 'Tasdiqlash',
    days: 'kun',
    notice: 'Qidirgan ketma-ketligi qolgan {{n}} kun yoki qancha qadar kamida, iltimos, portfoliya sizdagi gemilikni yaxshi yordam berishga urinib koʻring',
    notice2: 'Qidirgan ketma-ketligi 1 kun ichida, iltimos, portfoliya sizdagi gemilikni yaxshi yordam berishga urinib koʻring',
    notice3: "Ish haqi avtomatik ravishda to'langandan so'ng, olmos balansi avtomatik ravishda nolga teng bo'ladi. Agar kerak bo'lsa, olmosni oldindan oltin tangalarga almashtiring.",
    withdrawnSalary: 'Olingan maosh'
  },
  ru: {
    domTitle: 'Центр данных',
    timeText: 'Время',
    dataDetails: 'Детали данных',
    totallivetime: 'Общее время в эфире',
    bigTwoTime: '>=2 часа',
    receivGiftstreams: 'Полученные монеты',
    hostdetails: 'Детали ведущего',
    agencysalary: 'Зарплата агентства',
    presidentsalary: 'Зарплата президента',
    otherhostsalary: 'Зарплата других ведущих',
    Presidentcommission: 'Комиссия президента',
    Goldsalary: 'Зарплата в золоте',
    Diamondsalary: 'Зарплата в алмазах',
    Receivedgold: 'Полученное золото',
    diamondsalarylevel: 'Уровень зарплаты в алмазах',
    Cleardiamondcount: 'Очистка количества алмазов',
    Livetime: 'Время в эфире',
    Durationonmic: 'Продолжительность на микрофоне',
    TotalSalary: 'Общая зарплата',
    Receivedcoins: 'Полученные монеты',
    Coinssalarylevel: 'Уровень зарплаты в монетах',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    days: 'день',
    notice: 'Осталось {{n}} дней до сдачи, пожалуйста, как можно скорее воспользуйтесь драгоценными камнями в вашем кошельке',
    notice2: 'Сдача менее 1 дня, пожалуйста, как можно скорее воспользуйтесь драгоценными камнями в вашем кошельке',
    notice3: 'После того, как зарплата будет автоматически выплачена, баланс бриллиантов будет автоматически обнулен. При необходимости, заранее обменяйте бриллиант на золотые монеты.',
    withdrawnSalary: 'Выведенная зарплата'
  },
  fa: {
    domTitle: 'مرکز داده',
    timeText: 'زمان',
    dataDetails: 'جزئیات داده‌ها',
    totallivetime: 'زمان کل پخش زنده',
    bigTwoTime: '>=2 ساعت',
    receivGiftstreams: 'سکه‌های دریافتی',
    hostdetails: 'جزئیات میزبان',
    agencysalary: 'حقوق آژانس',
    presidentsalary: 'حقوق رئیس‌جمهور',
    otherhostsalary: 'حقوق سایر میزبان‌ها',
    Presidentcommission: 'کمیسیون رئیس‌جمهور',
    Goldsalary: 'حقوق طلا',
    Diamondsalary: 'حقوق الماس',
    Receivedgold: 'طلا دریافت شده',
    diamondsalarylevel: 'سطح حقوق الماس',
    Cleardiamondcount: 'تعداد الماس‌های پاک‌شده',
    Livetime: 'زمان پخش زنده',
    Durationonmic: 'مدت زمان استفاده از میکروفون',
    TotalSalary: 'حقوق کل',
    Receivedcoins: 'سکه‌های دریافتی',
    Coinssalarylevel: 'سطح حقوق سکه‌ها',
    cancel: 'لغو',
    confirm: 'تأیید',
    days: 'روز',
    notice: 'هنوز {{n}} روز تا تسویه حساب باقی مانده است، لطفاً در اسرع وقت از الماس موجود در کیف پول خود استفاده کنید.',
    notice2: 'چکشن کمتر از 1 روز است، لطفا دلارهایی که در کیف پول شما موجود هستند را به ابتدای امور استفاده کنید',
    notice3: 'پس از تسویه حساب، موجودی از دلارهایی که در کیف پول شما موجود هستند، به طور خودکار برای شما پاک خواهد شد، آنها را برای شما تبدیل کنید',
    withdrawnSalary: 'حقوق برداشت شده'
  },
  ur: {
    domTitle: 'ڈیٹا سینٹر',
    timeText: 'وقت',
    dataDetails: 'ڈیٹا کی تفصیلات',
    totallivetime: 'کل لائیو وقت',
    bigTwoTime: '≥2 گھنٹے',
    receivGiftstreams: 'موصولہ سکے',
    hostdetails: 'میزبان کی تفصیلات',
    agencysalary: 'ایجنسی تنخواہ',
    presidentsalary: 'صدر کی تنخواہ',
    otherhostsalary: 'دیگر میزبان تنخواہ',
    Presidentcommission: 'صدر کمیشن',
    Goldsalary: 'گولڈ تنخواہ',
    Diamondsalary: 'ڈائمنڈ تنخواہ',
    Receivedgold: 'موصولہ گولڈ',
    diamondsalarylevel: 'ڈائمنڈ تنخواہ لیول',
    Cleardiamondcount: 'صاف ڈائمنڈ کاؤنٹ',
    Livetime: 'لائیو وقت',
    Durationonmic: 'مائیک پر دورانیہ',
    TotalSalary: 'کل تنخواہ',
    Receivedcoins: 'موصولہ سکے',
    Coinssalarylevel: 'سکے تنخواہ لیول',
    cancel: 'منسوخ کریں',
    confirm: 'تصدیق کریں',
    days: 'دن',
    notice: 'سداد کیا جاتے ہیں، لطفاً کیف پول شما میں دلار کے ساتھ اپنا قدرت دیکھنے کی اجازت دیتا ہے',
    notice2: 'تصفیہ میں ابھی بھی {{n}} دن باقی ہیں، براہ کرم جلد از جلد اپنے بٹوے میں موجود ہیرا استعمال کریں',
    notice3: 'سداد کے بعد گِلڈ میں دلار کی حساب کا اوقاتی برائے گیا آئیں، جسے اگر ایک اور چیزی کی توجہ داری ہے، براہ کرم گِلڈ میں اپنا قدرت دیکھنے کی اجازت دیتا ہے',
    withdrawnSalary: 'واپس لیا گیا تنخواہ'
  }
}



// WEBPACK FOOTER //
// src/pages/app/datacenter/lang.js